import { useEffect, useState } from "react";
import { Link } from "wouter";
import ProgressLoader from "@/components/progress-loader";

const BASE = import.meta.env.BASE_URL;

export default function MentorEngagements() {
  const [rows, setRows] = useState<any[] | null>(null);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    const tok = localStorage.getItem("mentor_token") || "";
    fetch(`${BASE}api/mentor-portal/my-engagements`, { headers: { "x-mentor-token": tok } })
      .then(r => r.ok ? r.json() : r.json().then(d => Promise.reject(d.error || `${r.status}`)))
      .then(d => setRows(d.engagements))
      .catch(e => setErr(String(e)));
  }, []);

  if (err) return <div className="max-w-3xl mx-auto px-6 py-10 text-sm text-red-400">{err}</div>;
  if (!rows) return <div className="max-w-3xl mx-auto px-6 py-10"><ProgressLoader active={true} title="Loading" stages={["Loading your engagements"]} /></div>;

  return (
    <div className="max-w-4xl mx-auto px-6 py-8">
      <h1 className="text-2xl font-bold mb-6">Engagements</h1>
      {rows.length === 0 ? (
        <div className="bg-[var(--mentor-card)] border border-[var(--mentor-border)] rounded-lg p-8 text-center text-sm text-[var(--mentor-fg-muted)]">
          No active or completed engagements yet.
        </div>
      ) : (
        <div className="bg-[var(--mentor-card)] border border-[var(--mentor-border)] rounded-lg divide-y divide-[var(--mentor-border)]">
          {rows.map((r) => (
            <Link key={r.id} href={`/mentor/engagements/${r.id}`} className="block px-4 py-3 hover:bg-white/[0.03] transition-colors" data-testid={`engagement-row-${r.id}`}>
              <div className="flex items-start justify-between">
                <div>
                  <div className="text-sm font-medium">{r.missionTitle}</div>
                  <div className="text-xs text-[var(--mentor-fg-muted)]">{r.companyName} · invited {fmt(r.invitedAt)}{r.completedAt ? ` · completed ${fmt(r.completedAt)}` : ""}</div>
                  {r.compMode && <div className="text-[11px] text-[var(--mentor-fg-muted)] mt-0.5">Comp: {r.compMode}{r.compTermsAgreedAt ? " (terms agreed)" : " (terms pending)"}</div>}
                </div>
                <span className="text-[10px] font-medium px-2 py-0.5 rounded bg-zinc-500/15 text-zinc-300">{r.status}</span>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}

function fmt(d: string | null) { if (!d) return ""; return new Date(d).toLocaleDateString(); }
